export const clinicaYDoctorByPaisPRD = {
    "2": { cclinica: 1041, cdoctor: 1994 }, //colombia
    "4": { cclinica: 521, cdoctor: 514 }, //ecuador
    "7": { cclinica: 506, cdoctor: 686 }, //costa rica
    "10": { cclinica: 236, cdoctor: 496 }, //panama
    "12": { cclinica: 178, cdoctor: 96 }, //nicaragua
    "11": { cclinica: 186, cdoctor: 236 }, //guatemala
    "14": { cclinica: 154, cdoctor: 175 }, //honduras
    "13": { cclinica: 79, cdoctor: 19 }, //el salvador
};

export const clinicaYDoctorByPaisQA = {
    "2": { cclinica: 814, cdoctor: 1671 }, //colombia
    "4": { cclinica: 521, cdoctor: 514 }, //ecuador
    "7": { cclinica: 506, cdoctor: 686 }, //costa rica
    "10": { cclinica: 236, cdoctor: 496 }, //panama
    "12": { cclinica: 178, cdoctor: 96 }, //nicaragua
    "11": { cclinica: 186, cdoctor: 236 }, //guatemala
    "14": { cclinica: 154, cdoctor: 175 }, //honduras
    "13": { cclinica: 79, cdoctor: 19 }, //el salvador
};
